import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// types
import Project from '../../interfaces/Project.interface';

interface ProjectsState {
  projects: Project[];
  selectedProjectId: number | null;
  baseProjectId: number | null;
}

const initialState: ProjectsState = {
  projects: [],
  selectedProjectId: null,
  baseProjectId: null,
};

const projectsSlice = createSlice({
  name: 'projects',
  initialState,
  reducers: {
    setProjects: (state, action: PayloadAction<Project[]>) => {
      state.projects = action.payload;
    },
    setBaseProjectId: (state, action: PayloadAction<number>) => {
      state.baseProjectId = action.payload;
    },
    setSelectedProject: (state, action: PayloadAction<number | null>) => {
      state.selectedProjectId = action.payload;
    },
    createProject: (state, action: PayloadAction<Project>) => {
      state.projects.push(action.payload);
    },
    updateProject: (state, action: PayloadAction<Project>) => {
      const index = state.projects.findIndex((project: Project) => project.id === action.payload.id);
      if (index !== -1) {
        state.projects[index] = action.payload;
      }
    },
    deleteProject: (state, action: PayloadAction<number>) => {
      state.projects = state.projects.filter((project: Project) => project.id !== action.payload);
    },
  },
});

export const {
  setProjects,
  setBaseProjectId,
  setSelectedProject,
  createProject,
  updateProject,
  deleteProject
} = projectsSlice.actions;

export default projectsSlice.reducer;
